<script>

    import { createEventDispatcher } from 'svelte'
    import ProvidersMethods from '../$methods/providers.methods'

    export let provider = 'FedEx'
    export let service = ''
    export let isVoid = false
    export let hideLabels = false
    export let size = ''

    if(isVoid)
        provider = ''

    const dispatch = createEventDispatcher()

    let services = []

    const providers = ProvidersMethods.getProviders()
    const servicesList = ProvidersMethods.getServices()

    setServices()

    function setServices() {

        if(!provider)
            return

        services = provider? servicesList[provider] : servicesList.FedEx

        if(services.indexOf(service) === -1)
            service = services[0]

        if(isVoid)
            service = ''

        dispatch('change')
    }

</script>

<div class="columns is-mobile providers-row">
    <div class="column">
        {#if !hideLabels}
            <label for="" class="label">Proveedor</label>
        {/if}
        <div class="field">
            <div class="control">
                <div class="select is-fullwidth" class:is-small={size === 'small'}>
                    <!-- svelte-ignore a11y-no-onchange -->
                    <select bind:value={provider} on:change={setServices}>
                        {#if isVoid}
                            <option value="">Proveedor</option>
                        {/if}
                        {#each providers as providerItem}
                            <option value="{ providerItem }">{ providerItem }</option>
                        {/each}
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="column">
        {#if !hideLabels}
            <label for="" class="label">Servicio</label>
        {/if}
        <div class="field">
            <div class="control">
                <div class="select is-fullwidth" class:is-small={size === 'small'}>
                    <!-- svelte-ignore a11y-no-onchange -->
                    <select bind:value={service} on:change={() => dispatch('change')}>
                        {#if isVoid}
                            <option value="">Servicio</option>
                        {/if}
                        {#each services as serviceItem}
                            <option value="{ serviceItem }">{ serviceItem }</option>
                        {/each}
                    </select>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .providers-row {
        margin-left: 0 !important;
        margin-right: 0 !important;
        margin-top: 0 !important;
    }

    .providers-row .column {
        min-width: 0;
    }
</style>
